module.exports = __webpack_public_path__ + "static/media/programinfo.6023b2a4.svg";